import React, { useContext } from 'react';
import authContext from '@contexts/AuthContext';
import { Navigate } from 'react-router';
import RootLayout from '@layouts/RootLayout';
import AppRoutes from '@utilities/app-routes';
import { USER_TYPE } from '@utilities';

const WHITELISTED_ROUTES = [AppRoutes.PROFILE];

export const AuthenticatedRoute = ({ permission, children }: { permission?: any; children?: any }) => {
	const loggedIn: any = useContext(authContext);
	const userType = localStorage.getItem(USER_TYPE);

	if (!loggedIn.loggedIn) {
		return <Navigate to={AppRoutes.LOGIN} />;
	}

	const currentPath = window.location.pathname;
	const isWhitelisted = WHITELISTED_ROUTES.some(route => currentPath === route || currentPath.startsWith(route));

	const effectivePermission = isWhitelisted ? null : permission;

	return <RootLayout permission={effectivePermission}>{children}</RootLayout>;
};
